import "./styles/chat-bubble.scss"
import React, { ReactEventHandler } from "react"
import classNames from "classnames"

interface ChatBubbleProps {
    className?: string
    onClick?: ReactEventHandler<HTMLButtonElement>
    children?: React.ReactNode
}

const ChatBubble = ({ className, children, onClick, ...rest }: ChatBubbleProps) => {
    return onClick ? (
        <button
            className={classNames("meny-chat-bubble", className)}
            onClick={onClick}
            {...rest}
        >
            {children}
        </button>
    ) : (
        <div
            className={classNames("meny-chat-bubble", className)}
            {...rest}
        >
            {children}
        </div>
    )
}

export default ChatBubble
